import { TimeCluster } from 'hooks/useBroadcastTimeCluster/useBroadcastTimeCluster';

export type RecordingPlayerInitiator = 'recording' | 'broadcast';

export enum RecordingEvent {
    GET_ALL = 'GET_ALL',
    MANAGE = 'MANAGE',
    ADD = 'ADD',
    DELETE = 'DELETE',
}

export type RecordingType = 'RECORDED' | 'ONGOING' | 'SCHEDULED';

export type RecordingRelationRef = {
    id: string;
    eventId: string;
};

export type RecordingRef = {
    id: string;
    recordingId?: string;
    assetId?: string;
    type?: RecordingType;
    skipNotification?: boolean;
};

export type RecordingQuota = {
    all: number;
    remaining: number;
};

export type RecordingListingProgram = {
    id: string;
    title?: string;
    program_series_id?: string;
};

export type RecordingListing = {
    id: string;
    channel_id: string;
    start: number;
    duration: number;
    outdated?: boolean;
    program?: RecordingListingProgram;
};

export type RecordingListItem = {
    id: string;
    created_at: number;
    expires_at: number;
    listing: RecordingListing;
};

export type RecordingListResponse = {
    count: number;
    pages: number;
    recording_limit: number;
    recording_limit_used: number;
    results: RecordingListItem[];
};

export const TimeClusterRecordingTypeMap: { [key in TimeCluster]: RecordingType } = {
    PAST: 'RECORDED',
    LIVE: 'ONGOING',
    FUTURE: 'SCHEDULED',
};
